import { Link, router } from "@inertiajs/react"
import { Menu, X } from "lucide-react"
import { useEffect, useMemo, useState } from "react"

const navItems = [
  { href: "/", label: "Latest Reports" },
  { href: "/cities", label: "City Silos" },
  { href: "/dispatch", label: "Dispatch" }
]

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false)
  const items = useMemo(() => navItems, [])
  const [currentPath, setCurrentPath] = useState<string>(() =>
    typeof window !== "undefined" ? window.location.pathname : "/"
  )

  useEffect(() => {
    const removeListener = router.on("success", () => {
      setCurrentPath(window.location.pathname)
    })

    return () => {
      removeListener()
    }
  }, [])

  const isActive = (href: string) => {
    if (href === "/") return currentPath === "/"
    return currentPath === href || currentPath.startsWith(`${href}/`)
  }

  return (
    <header className="relative z-20 w-full border-b border-[hsl(var(--ch-primary))] bg-[hsl(var(--ch-bg))]">
      <div className="ch-container py-6 pb-3">
        <div className="relative mb-6 border-y-2 border-[hsl(var(--ch-primary))] py-2 text-center">
          <Link className="ch-masthead inline-block text-[hsl(var(--ch-primary))]" href="/">
            CITY HALLER
          </Link>
          <button
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
            className="absolute right-0 top-1/2 -translate-y-1/2 border border-[hsl(var(--ch-primary))] p-2 text-[hsl(var(--ch-primary))] md:hidden"
            onClick={() => setIsOpen((open) => !open)}
            type="button"
          >
            {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
        <nav className="relative">
          <ul className={`${isOpen ? "flex" : "hidden"} flex-col gap-4 border-t border-[hsl(var(--ch-primary))] pt-4 md:flex md:flex-row md:flex-wrap md:justify-center md:gap-x-8 md:gap-y-4 md:border-0 md:pt-0`}>
            {items.map((item) => (
              <li key={item.label}>
                <Link
                  className={`ch-label-caps border-b pb-1 transition-colors ${
                    isActive(item.href)
                      ? "border-[hsl(var(--ch-primary))] text-[hsl(var(--ch-primary))]"
                      : "border-transparent text-[hsl(var(--ch-muted))] hover:border-[hsl(var(--ch-primary))] hover:text-[hsl(var(--ch-primary))]"
                  }`}
                  href={item.href}
                  onClick={() => setIsOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  )
}
